import { useTranslation } from 'react-i18next';
import '../styles/language-switcher.css';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'ja' : 'en';
    i18n.changeLanguage(newLang);
  };

  return (
    <button
      className="language-switcher-btn"
      onClick={toggleLanguage}
      title={i18n.language === 'en' ? 'Switch to Japanese' : 'Switch to English'}
    >
      {i18n.language === 'en' ? '日本語' : 'English'}
    </button>
  );
};

export default LanguageSwitcher;
